export const QUESTIONS = [
  {
    "id": 1,
    "text": "I can identify my emotions as they happen.",
    "domain": "SA",
    "sub": "Emotional Awareness",
    "keyed": 1
  },
  {
    "id": 2,
    "text": "I notice how my mood affects my thinking.",
    "domain": "SA",
    "sub": "Emotional Awareness",
    "keyed": 1
  },
  {
    "id": 3,
    "text": "I am often unsure what I am feeling.",
    "domain": "SA",
    "sub": "Emotional Awareness",
    "keyed": -1
  },
  {
    "id": 4,
    "text": "I recognise which emotions are driving my behaviour in the moment.",
    "domain": "SA",
    "sub": "Emotional Awareness",
    "keyed": 1
  },
  {
    "id": 5,
    "text": "My emotions often take me by surprise.",
    "domain": "SA",
    "sub": "Emotional Awareness",
    "keyed": -1
  },
  {
    "id": 6,
    "text": "I can describe my emotional state with precision.",
    "domain": "SA",
    "sub": "Emotional Awareness",
    "keyed": 1
  },
  {
    "id": 7,
    "text": "I have a realistic picture of my strengths and weaknesses.",
    "domain": "SA",
    "sub": "Accurate Self-Assessment",
    "keyed": 1
  },
  {
    "id": 8,
    "text": "I am open to honest feedback about my performance.",
    "domain": "SA",
    "sub": "Accurate Self-Assessment",
    "keyed": 1
  },
  {
    "id": 9,
    "text": "I tend to overestimate my abilities.",
    "domain": "SA",
    "sub": "Accurate Self-Assessment",
    "keyed": -1
  },
  {
    "id": 10,
    "text": "I reflect regularly on what I could do better.",
    "domain": "SA",
    "sub": "Accurate Self-Assessment",
    "keyed": 1
  },
  {
    "id": 11,
    "text": "I find it difficult to acknowledge my own weaknesses.",
    "domain": "SA",
    "sub": "Accurate Self-Assessment",
    "keyed": -1
  },
  {
    "id": 12,
    "text": "I learn from my mistakes rather than repeating them.",
    "domain": "SA",
    "sub": "Accurate Self-Assessment",
    "keyed": 1
  },
  {
    "id": 13,
    "text": "I trust my own judgment even when others disagree.",
    "domain": "SA",
    "sub": "Self-Confidence",
    "keyed": 1
  },
  {
    "id": 14,
    "text": "I feel confident presenting my ideas to senior people.",
    "domain": "SA",
    "sub": "Self-Confidence",
    "keyed": 1
  },
  {
    "id": 15,
    "text": "I doubt myself when faced with difficult challenges.",
    "domain": "SA",
    "sub": "Self-Confidence",
    "keyed": -1
  },
  {
    "id": 16,
    "text": "I am comfortable asserting my views in group settings.",
    "domain": "SA",
    "sub": "Self-Confidence",
    "keyed": 1
  },
  {
    "id": 17,
    "text": "I often worry about what others think of me.",
    "domain": "SA",
    "sub": "Self-Confidence",
    "keyed": -1
  },
  {
    "id": 18,
    "text": "I have a strong sense of my own values and identity.",
    "domain": "SA",
    "sub": "Self-Confidence",
    "keyed": 1
  },
  {
    "id": 19,
    "text": "I can name a wide range of emotions beyond 'happy' or 'sad'.",
    "domain": "SA",
    "sub": "Emotional Literacy",
    "keyed": 1
  },
  {
    "id": 20,
    "text": "I understand how different situations trigger different emotions in me.",
    "domain": "SA",
    "sub": "Emotional Literacy",
    "keyed": 1
  },
  {
    "id": 21,
    "text": "I struggle to put my feelings into words.",
    "domain": "SA",
    "sub": "Emotional Literacy",
    "keyed": -1
  },
  {
    "id": 22,
    "text": "I can distinguish between feeling anxious and feeling frustrated.",
    "domain": "SA",
    "sub": "Emotional Literacy",
    "keyed": 1
  },
  {
    "id": 23,
    "text": "I find emotions confusing and prefer not to think about them.",
    "domain": "SA",
    "sub": "Emotional Literacy",
    "keyed": -1
  },
  {
    "id": 24,
    "text": "I understand the connection between my thoughts, feelings and actions.",
    "domain": "SA",
    "sub": "Emotional Literacy",
    "keyed": 1
  },
  {
    "id": 25,
    "text": "I remain calm under pressure.",
    "domain": "SR",
    "sub": "Emotional Control",
    "keyed": 1
  },
  {
    "id": 26,
    "text": "I can manage disruptive emotions without letting them take over.",
    "domain": "SR",
    "sub": "Emotional Control",
    "keyed": 1
  },
  {
    "id": 27,
    "text": "I say things I regret when I am stressed or angry.",
    "domain": "SR",
    "sub": "Emotional Control",
    "keyed": -1
  },
  {
    "id": 28,
    "text": "I can pause and think before reacting emotionally.",
    "domain": "SR",
    "sub": "Emotional Control",
    "keyed": 1
  },
  {
    "id": 29,
    "text": "I find it hard to control my temper in difficult situations.",
    "domain": "SR",
    "sub": "Emotional Control",
    "keyed": -1
  },
  {
    "id": 30,
    "text": "I recover quickly after setbacks or disappointments.",
    "domain": "SR",
    "sub": "Emotional Control",
    "keyed": 1
  },
  {
    "id": 31,
    "text": "I adapt well when circumstances change unexpectedly.",
    "domain": "SR",
    "sub": "Adaptability",
    "keyed": 1
  },
  {
    "id": 32,
    "text": "I become anxious or resistant when plans change at short notice.",
    "domain": "SR",
    "sub": "Adaptability",
    "keyed": -1
  },
  {
    "id": 33,
    "text": "I can shift priorities without losing effectiveness.",
    "domain": "SR",
    "sub": "Adaptability",
    "keyed": 1
  },
  {
    "id": 34,
    "text": "I handle ambiguity and uncertainty with composure.",
    "domain": "SR",
    "sub": "Adaptability",
    "keyed": 1
  },
  {
    "id": 35,
    "text": "I struggle to perform well when the environment is chaotic.",
    "domain": "SR",
    "sub": "Adaptability",
    "keyed": -1
  },
  {
    "id": 36,
    "text": "I see change as an opportunity rather than a threat.",
    "domain": "SR",
    "sub": "Adaptability",
    "keyed": 1
  },
  {
    "id": 37,
    "text": "My behaviour is consistent with my stated values.",
    "domain": "SR",
    "sub": "Integrity",
    "keyed": 1
  },
  {
    "id": 38,
    "text": "I take responsibility for my actions even when things go wrong.",
    "domain": "SR",
    "sub": "Integrity",
    "keyed": 1
  },
  {
    "id": 39,
    "text": "I sometimes bend the rules when I think it is justified.",
    "domain": "SR",
    "sub": "Integrity",
    "keyed": -1
  },
  {
    "id": 40,
    "text": "People know they can rely on me to follow through on commitments.",
    "domain": "SR",
    "sub": "Integrity",
    "keyed": 1
  },
  {
    "id": 41,
    "text": "I avoid difficult conversations when I know I am in the wrong.",
    "domain": "SR",
    "sub": "Integrity",
    "keyed": -1
  },
  {
    "id": 42,
    "text": "I am transparent about my motives and intentions with others.",
    "domain": "SR",
    "sub": "Integrity",
    "keyed": 1
  },
  {
    "id": 43,
    "text": "I think carefully before making important decisions.",
    "domain": "SR",
    "sub": "Impulse Control",
    "keyed": 1
  },
  {
    "id": 44,
    "text": "I sometimes act on impulse and regret it later.",
    "domain": "SR",
    "sub": "Impulse Control",
    "keyed": -1
  },
  {
    "id": 45,
    "text": "I can delay gratification in pursuit of longer-term goals.",
    "domain": "SR",
    "sub": "Impulse Control",
    "keyed": 1
  },
  {
    "id": 46,
    "text": "I interrupt people when I am excited or impatient.",
    "domain": "SR",
    "sub": "Impulse Control",
    "keyed": -1
  },
  {
    "id": 47,
    "text": "I resist the temptation to make hasty judgments.",
    "domain": "SR",
    "sub": "Impulse Control",
    "keyed": 1
  },
  {
    "id": 48,
    "text": "I can sit with discomfort rather than reacting immediately.",
    "domain": "SR",
    "sub": "Impulse Control",
    "keyed": 1
  },
  {
    "id": 49,
    "text": "I set ambitious goals and work hard to achieve them.",
    "domain": "MO",
    "sub": "Achievement Drive",
    "keyed": 1
  },
  {
    "id": 50,
    "text": "I push myself to continuously improve my performance.",
    "domain": "MO",
    "sub": "Achievement Drive",
    "keyed": 1
  },
  {
    "id": 51,
    "text": "I am satisfied with doing just enough to get by.",
    "domain": "MO",
    "sub": "Achievement Drive",
    "keyed": -1
  },
  {
    "id": 52,
    "text": "I look for ways to do things better, even when results are good.",
    "domain": "MO",
    "sub": "Achievement Drive",
    "keyed": 1
  },
  {
    "id": 53,
    "text": "I feel a strong sense of purpose in my work.",
    "domain": "MO",
    "sub": "Commitment",
    "keyed": 1
  },
  {
    "id": 54,
    "text": "I align my personal goals with the goals of my organisation.",
    "domain": "MO",
    "sub": "Commitment",
    "keyed": 1
  },
  {
    "id": 55,
    "text": "I often feel disengaged from my work.",
    "domain": "MO",
    "sub": "Commitment",
    "keyed": -1
  },
  {
    "id": 56,
    "text": "I go beyond my role to contribute to team and organisational success.",
    "domain": "MO",
    "sub": "Commitment",
    "keyed": 1
  },
  {
    "id": 57,
    "text": "I take action on opportunities without waiting to be told.",
    "domain": "MO",
    "sub": "Initiative",
    "keyed": 1
  },
  {
    "id": 58,
    "text": "I proactively look for ways to solve problems before they escalate.",
    "domain": "MO",
    "sub": "Initiative",
    "keyed": 1
  },
  {
    "id": 59,
    "text": "I tend to wait for others to take the lead.",
    "domain": "MO",
    "sub": "Initiative",
    "keyed": -1
  },
  {
    "id": 60,
    "text": "I am comfortable starting things even when the outcome is uncertain.",
    "domain": "MO",
    "sub": "Initiative",
    "keyed": 1
  },
  {
    "id": 61,
    "text": "I approach challenges with the expectation that I will overcome them.",
    "domain": "MO",
    "sub": "Optimism",
    "keyed": 1
  },
  {
    "id": 62,
    "text": "I tend to focus on what can go wrong rather than what can go right.",
    "domain": "MO",
    "sub": "Optimism",
    "keyed": -1
  },
  {
    "id": 63,
    "text": "I maintain a positive outlook even in difficult circumstances.",
    "domain": "MO",
    "sub": "Optimism",
    "keyed": 1
  },
  {
    "id": 64,
    "text": "I believe that persistence usually leads to success.",
    "domain": "MO",
    "sub": "Optimism",
    "keyed": 1
  },
  {
    "id": 65,
    "text": "I accurately sense what others are feeling even when they say little.",
    "domain": "EM",
    "sub": "Understanding Others",
    "keyed": 1
  },
  {
    "id": 66,
    "text": "I pay close attention to non-verbal cues in conversations.",
    "domain": "EM",
    "sub": "Understanding Others",
    "keyed": 1
  },
  {
    "id": 67,
    "text": "I find it hard to understand why people feel the way they do.",
    "domain": "EM",
    "sub": "Understanding Others",
    "keyed": -1
  },
  {
    "id": 68,
    "text": "I can see situations from other people's perspectives easily.",
    "domain": "EM",
    "sub": "Understanding Others",
    "keyed": 1
  },
  {
    "id": 69,
    "text": "I am genuinely curious about the inner world of people I work with.",
    "domain": "EM",
    "sub": "Understanding Others",
    "keyed": 1
  },
  {
    "id": 70,
    "text": "I invest time in understanding what motivates the people I work with.",
    "domain": "EM",
    "sub": "Developing Others",
    "keyed": 1
  },
  {
    "id": 71,
    "text": "I give honest, constructive feedback that helps people grow.",
    "domain": "EM",
    "sub": "Developing Others",
    "keyed": 1
  },
  {
    "id": 72,
    "text": "I rarely have time to focus on developing others.",
    "domain": "EM",
    "sub": "Developing Others",
    "keyed": -1
  },
  {
    "id": 73,
    "text": "I notice when someone is struggling and offer support.",
    "domain": "EM",
    "sub": "Developing Others",
    "keyed": 1
  },
  {
    "id": 74,
    "text": "I celebrate others' successes genuinely and enthusiastically.",
    "domain": "EM",
    "sub": "Developing Others",
    "keyed": 1
  },
  {
    "id": 75,
    "text": "I genuinely care about the experience of the people I serve.",
    "domain": "EM",
    "sub": "Service Orientation",
    "keyed": 1
  },
  {
    "id": 76,
    "text": "I go out of my way to understand the needs of clients or stakeholders.",
    "domain": "EM",
    "sub": "Service Orientation",
    "keyed": 1
  },
  {
    "id": 77,
    "text": "I find customer-facing work draining and prefer to work alone.",
    "domain": "EM",
    "sub": "Service Orientation",
    "keyed": -1
  },
  {
    "id": 78,
    "text": "I take pride in delivering experiences that exceed expectations.",
    "domain": "EM",
    "sub": "Service Orientation",
    "keyed": 1
  },
  {
    "id": 79,
    "text": "I proactively seek to understand the longer-term needs of others.",
    "domain": "EM",
    "sub": "Service Orientation",
    "keyed": 1
  },
  {
    "id": 80,
    "text": "I value working with people from backgrounds different from my own.",
    "domain": "EM",
    "sub": "Leveraging Diversity",
    "keyed": 1
  },
  {
    "id": 81,
    "text": "I adjust my communication style to suit different people.",
    "domain": "EM",
    "sub": "Leveraging Diversity",
    "keyed": 1
  },
  {
    "id": 82,
    "text": "I sometimes feel impatient with people who think very differently.",
    "domain": "EM",
    "sub": "Leveraging Diversity",
    "keyed": -1
  },
  {
    "id": 83,
    "text": "I actively seek out diverse perspectives when making decisions.",
    "domain": "EM",
    "sub": "Leveraging Diversity",
    "keyed": 1
  },
  {
    "id": 84,
    "text": "I am aware of my own biases and work to manage them.",
    "domain": "EM",
    "sub": "Leveraging Diversity",
    "keyed": 1
  },
  {
    "id": 85,
    "text": "I can persuade others by appealing to their interests and values.",
    "domain": "SS",
    "sub": "Influence",
    "keyed": 1
  },
  {
    "id": 86,
    "text": "I build coalitions and support for ideas before formally presenting them.",
    "domain": "SS",
    "sub": "Influence",
    "keyed": 1
  },
  {
    "id": 87,
    "text": "I struggle to get buy-in from people who don't immediately agree.",
    "domain": "SS",
    "sub": "Influence",
    "keyed": -1
  },
  {
    "id": 88,
    "text": "I tailor my message to resonate with different audiences.",
    "domain": "SS",
    "sub": "Influence",
    "keyed": 1
  },
  {
    "id": 89,
    "text": "I listen attentively without thinking about my response.",
    "domain": "SS",
    "sub": "Communication",
    "keyed": 1
  },
  {
    "id": 90,
    "text": "I communicate complex ideas in a clear and accessible way.",
    "domain": "SS",
    "sub": "Communication",
    "keyed": 1
  },
  {
    "id": 91,
    "text": "People have told me I am not a good listener.",
    "domain": "SS",
    "sub": "Communication",
    "keyed": -1
  },
  {
    "id": 92,
    "text": "I create space for others to share their views in conversations.",
    "domain": "SS",
    "sub": "Communication",
    "keyed": 1
  },
  {
    "id": 93,
    "text": "I address conflict directly rather than avoiding it.",
    "domain": "SS",
    "sub": "Conflict Management",
    "keyed": 1
  },
  {
    "id": 94,
    "text": "I find ways to de-escalate tense situations.",
    "domain": "SS",
    "sub": "Conflict Management",
    "keyed": 1
  },
  {
    "id": 95,
    "text": "I avoid difficult conversations even when they are necessary.",
    "domain": "SS",
    "sub": "Conflict Management",
    "keyed": -1
  },
  {
    "id": 96,
    "text": "I help others find common ground when they disagree.",
    "domain": "SS",
    "sub": "Conflict Management",
    "keyed": 1
  }
];
export const QUESTIONS_PER_PAGE = 8;
export const TOTAL_PAGES = Math.ceil(QUESTIONS.length / QUESTIONS_PER_PAGE);
